/**
 * The Pro price, in the smallest currency unit (cents), so the UI can show
 * what the NEXT charge will actually be once coins are taken off.
 *
 * Before this, /subscription showed "Fluent Pro — $5/თვეში" on one line and
 * "−278 მონეტა (−$1.03)" on another, and left the learner to do the
 * subtraction (audit F089, 2026-09-22).
 *
 * MUST move together with the Paddle price and with the default in
 * `functions/api/play-redeem.ts` — three places, one number. It is not read
 * from Paddle because this line paints instantly from the cached row, before
 * any network call.
 */
export const PRO_PRICE_CENTS = 500;

/**
 * What the next charge comes to after a scheduled coin discount, in cents.
 * Clamped at 0: a discount can never turn into a payout.
 */
export function nextChargeCents(discountCents: number): number {
  return Math.max(0, PRO_PRICE_CENTS - discountCents);
}

/** "$3.97" — the app sells in USD only (DECISIONS 2026-04-16). */
export function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}
